import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_trainee_list",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "trainee_list",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_trainee_list_button",
  "data-kt-drawer-close": "#kt_drawer_trainee_list_close",
  "data-kt-drawer-width": "72.5vw"
}
const _hoisted_2 = {
  id: "kt_trainee_list",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_trainee_list_header\"><h2 class=\"fw-bolder text-light my-auto\">Edit Info</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_trainee_list_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_trainee_list_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_trainee_list_body",
  "data-kt-scroll-dependencies": "#kt_trainee_list_header, #kt_trainee_list_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_trainee_list_scroll"
}
const _hoisted_8 = { class: "card mb-5 mb-xl-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Application Information")
  ])
], -1)
const _hoisted_10 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_11 = { class: "collapse show" }
const _hoisted_12 = { class: "card-body border-top p-9" }
const _hoisted_13 = { class: "row d-flex" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload Trainee Photo", -1)
const _hoisted_16 = { id: "preview" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { class: "row mt-3 d-flex" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Father Name", -1)
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, " Mother Name ", -1)
const _hoisted_27 = { class: "row mt-3 d-flex" }
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_32 = { class: "row mt-3 d-flex" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Upazilla")
], -1)
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Post Code")
], -1)
const _hoisted_37 = { class: "row mt-3" }
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "Permanent District", -1)
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Upazilla")
], -1)
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Post Code")
], -1)
const _hoisted_46 = { class: "card mb-5 mb-xl-10" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#personal_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Personal Information")
  ])
], -1)
const _hoisted_48 = {
  id: "personal_information",
  class: "collapse show"
}
const _hoisted_49 = { class: "collapse show" }
const _hoisted_50 = { class: "card-body border-top p-9" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-md-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Reference Id", -1)
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mobile", -1)
const _hoisted_56 = { class: "col-md-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Alternative Mobile")
], -1)
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_60 = { class: "row mt-3" }
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ethnic Group")
], -1)
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Highest Class Completed")
], -1)
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Passing Year")
], -1)
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Is Employed?")
], -1)
const _hoisted_69 = { class: "row mt-3" }
const _hoisted_70 = { class: "col-md-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Years of Experience")
], -1)
const _hoisted_72 = { class: "col-md-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Personal Monthly Income")
], -1)
const _hoisted_74 = { class: "col-md-3" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Home District")
], -1)
const _hoisted_76 = { class: "col-md-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Home Upazilla")
], -1)
const _hoisted_78 = { class: "row mt-3" }
const _hoisted_79 = { class: "col-md-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Is Physically Challenged?")
], -1)
const _hoisted_81 = { class: "col-md-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Remarks")
], -1)
const _hoisted_83 = { class: "col-md-3" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_85 = { class: "col-md-3" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Gender", -1)
const _hoisted_87 = { class: "card mb-5 mb-xl-10" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#family_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Family Information")
  ])
], -1)
const _hoisted_89 = {
  id: "family_information",
  class: "collapse show"
}
const _hoisted_90 = { class: "collapse show" }
const _hoisted_91 = { class: "card-body border-top p-9" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-md-3" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mother's Education Level", -1)
const _hoisted_95 = { class: "col-md-3" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mother's Occupation", -1)
const _hoisted_97 = { class: "col-md-3" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Education Level")
], -1)
const _hoisted_99 = { class: "col-md-3" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Occupation")
], -1)
const _hoisted_101 = { class: "row mt-3" }
const _hoisted_102 = { class: "col-md-3" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Family Annual Income")
], -1)
const _hoisted_104 = { class: "col-md-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Number of Siblings?")
], -1)
const _hoisted_106 = { class: "col-md-3" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Have family owned home?", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_109 = { class: "col-md-3" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Have family owned land?", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_112 = {
  class: "card-footer py-5 text-center",
  id: "kt_trainee_list_footer"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_trainee_list_close",
  class: "btn btn-danger me-5"
}, " Close ", -1)
const _hoisted_114 = ["data-kt-indicator"]
const _hoisted_115 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_116 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_117 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_label_el = _resolveComponent("label-el")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.photo,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.photo) = $event)),
                                name: "photo",
                                ref: "traineeFileInput",
                                onChange: _ctx.traineePhoto,
                                type: "file",
                                class: "form-control"
                              }, null, 8, ["modelValue", "onChange"]),
                              _createElementVNode("div", _hoisted_16, [
                                (_ctx.url)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.url
                                    }, null, 8, _hoisted_17))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: 
                                  this.formData?.attach_file_info?.file_path
                                    ? _ctx.api_url +
                                      this.formData?.attach_file_info?.file_path
                                    : 'media/avatars/blank.png'
                                
                                    }, null, 8, _hoisted_18))
                              ]),
                              _createVNode(_component_ErrorMessage, {
                                name: "trainee_image",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.trainee_name,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.trainee_name) = $event)),
                                    type: "text",
                                    name: "name",
                                    class: "form-control form-control-sm",
                                    style: {"height":"40px","width":"100%"},
                                    disabled: _ctx.validated == 1
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "name",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                  _hoisted_24,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.father_name,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.father_name) = $event)),
                                    name: "father_name",
                                    class: "form-control form-control-sm",
                                    style: {"height":"40px","width":"100%"},
                                    disabled: _ctx.validated == 1
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "father_name",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _hoisted_26,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.mother_name,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mother_name) = $event)),
                                    name: "mother_name",
                                    class: "form-control form-control-sm",
                                    style: {"height":"40px","width":"100%"},
                                    disabled: _ctx.validated == 1
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "mother_name",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.present_address,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.present_address) = $event)),
                                    name: "present_address",
                                    class: "form-control form-control-sm",
                                    style: {"height":"40px","width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _hoisted_31,
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select District",
                                    modelValue: _ctx.formData.present_district,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.present_district) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getSubDistrict()))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: district.id,
                                          label: district.district_name_eng,
                                          value: district.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "present_districts",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _hoisted_34,
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Upazilla",
                                    modelValue: _ctx.formData.present_upazilla,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.present_upazilla) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subDistricts, (sub_district) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: sub_district.id,
                                          label: sub_district.upazila_name_eng,
                                          value: sub_district.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(sub_district.upazila_name_eng), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "present_upazilla",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.formData.present_post_code,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.present_post_code) = $event)),
                                    name: "present_post_code",
                                    class: "form-control form-control-sm",
                                    style: {"height":"40px","width":"100%"}
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "present_post_code",
                                    class: "fv-plugins-message-container invalid-feedback"
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _hoisted_39,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.per_address,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.per_address) = $event)),
                                name: "permanent_address",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_label_el, { class: "d-flex align-items-center form-label required" }, {
                                default: _withCtx(() => [
                                  _hoisted_41
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select District",
                                modelValue: _ctx.formData.per_district,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.per_district) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getPermanentSubDistrict()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: district.id,
                                      label: district.district_name_eng,
                                      value: district.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "permanent_districts",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _hoisted_43,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Upazilla",
                                modelValue: _ctx.formData.per_upazilla,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.per_upazilla) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subPermanentDistrict, (subpermanent_district) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: subpermanent_district.id,
                                      label: subpermanent_district.upazila_name_eng,
                                      value: subpermanent_district.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(subpermanent_district.upazila_name_eng), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "permanent_upazilla",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.per_post_code,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.per_post_code) = $event)),
                                name: "post_code_address",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "per_post_code",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _hoisted_53,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.reference_number,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.reference_number) = $event)),
                                type: "text",
                                name: "reference_number",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "ref_id",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.mobile,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                                name: "mobile",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "mobile",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.alternative_mobile,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.alternative_mobile) = $event)),
                                name: "alt_mobile",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"},
                                value: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _hoisted_59,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.email,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.email) = $event)),
                                name: "email",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "email",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Class",
                                modelValue: _ctx.formData.ethnic_group,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.ethnic_group) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ethnicGroups, (group) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: group.id,
                                      label: group.group_name,
                                      value: group.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(group.group_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Class",
                                modelValue: _ctx.formData.highest_class_completed,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.highest_class_completed) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "PHD" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("PHD")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Masters" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Masters")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Bachelor" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Bachelor")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Diploma" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Diploma")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "HSC" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("HSC")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "SSC" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("SSC")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "JSC" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("JSC")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "PSC" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("PSC")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Bellow Class-5" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Bellow Class-5")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Class",
                                modelValue: _ctx.formData.highest_class_completed_year,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.highest_class_completed_year) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(45, (index) => {
                                    return _createVNode(_component_el_option, {
                                      label: _ctx.currentYear + 1 - index,
                                      key: index,
                                      value: _ctx.currentYear + 1 - index
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.currentYear + 1 - index), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"])
                                  }), 64))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "passing_year",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _hoisted_68,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Status",
                                modelValue: _ctx.formData.is_employed,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.is_employed) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Yes" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Yes")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "No" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("No")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "is_employee",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.year_of_experience,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.year_of_experience) = $event)),
                                name: "experience_year",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.family_monthly_income,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.family_monthly_income) = $event)),
                                name: "monthly_income",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select District",
                                modelValue: _ctx.formData.home_district,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.home_district) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.getHomeSubDistrict()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: district.id,
                                      label: district.district_name_eng,
                                      value: district.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _hoisted_77,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Upazilla",
                                modelValue: _ctx.formData.home_upazilla,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.home_upazilla) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subHomeSubDistrict, (subpermanent_district) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: subpermanent_district.id,
                                      label: subpermanent_district.upazila_name_eng,
                                      value: subpermanent_district.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(subpermanent_district.upazila_name_eng), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _hoisted_80,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Status",
                                modelValue: _ctx.formData.is_physically_challenged,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.is_physically_challenged) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Yes" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Yes")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "No" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("No")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "is_physically",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_81, [
                              _hoisted_82,
                              _createVNode(_component_Field, {
                                name: "remarks",
                                modelValue: _ctx.formData.challenge_remarks,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.challenge_remarks) = $event)),
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "remarks",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _hoisted_84,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Status",
                                modelValue: _ctx.formData.religion,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.religion) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Islam" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Islam")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Hindu" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Hindu")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Christian" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Christian")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Buddhist" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Buddhist")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "religion",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _hoisted_86,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Status",
                                modelValue: _ctx.formData.gender,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.gender) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                disabled: _ctx.validated == 1
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Male" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Male")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Female" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Female")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Other" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Other")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "gender",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _hoisted_94,
                              _createVNode(_component_Field, {
                                type: "text",
                                name: "mother_education_level",
                                modelValue: _ctx.formData.mother_education_level,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.mother_education_level) = $event)),
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "mother_edu",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _hoisted_96,
                              _createVNode(_component_Field, {
                                name: "mother_occ",
                                modelValue: _ctx.formData.mother_occupation,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.mother_occupation) = $event)),
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "mother_occ",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_97, [
                              _hoisted_98,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.father_education_level,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.father_education_level) = $event)),
                                name: "father_edu",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_99, [
                              _hoisted_100,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.father_occupation,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.father_occupation) = $event)),
                                name: "father_occ",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _hoisted_103,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.father_annual_income,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.father_annual_income) = $event)),
                                name: "family_income",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _hoisted_105,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.number_of_siblings,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.number_of_siblings) = $event)),
                                name: "sibling_no",
                                type: "number",
                                min: "0",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _hoisted_107,
                              _hoisted_108,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Status",
                                modelValue: _ctx.formData.have_family_owned_home,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.have_family_owned_home) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Yes" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Yes")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "No" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("No")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "family_own_home",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_109, [
                              _hoisted_110,
                              _hoisted_111,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Status",
                                modelValue: _ctx.formData.have_family_owned_land,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.have_family_owned_land) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Yes" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Yes")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "No" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("No")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "family_own_land",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_115, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_116, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_117, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_118
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_114)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ]))
}